export const aboutData = {
  title: 'Who I am',
  description1: "My name's Amin. I'm a React developer based in Surat, India.",
  description2:
    'Experienced React developer with 2.5+ years of delivering successful web applications. Strong skills in building high-performance UI components, understanding of modern React libraries and proficiency for managing application state. Committed to writing clean and maintainable code, and continuously learning new technologies to stay current with industry trends.',
  image: 1,
};
